import {KatNavigation} from "@amzn/katal-react";
import * as React from "react";
import {NavLink} from "react-router-dom";


const LeftNavigation = () => {

    return (
        <div slot="left">
            <KatNavigation mode="vertical">
                <NavLink exact={true} to="/data/export" activeClassName='active-link'>Review Export</NavLink>
                <NavLink exact={false} to="/review" activeClassName='active-link'>Review Detail</NavLink>
            </KatNavigation>
        </div>
    );
}

export default LeftNavigation;